export const FEATURE_FLAGS = {
  DOWNLOAD_COMPROVANTE_SEGMENTO_Z: 'download-comprovante-segmento-z',
};
